module.exports = __webpack_public_path__ + "static/media/Read-Regular_V1100.be8f7343.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Regular_V1100.woff
// module id = 646
// module chunks = 0